import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { Button, Card } from 'react-bootstrap';
import { Loader } from 'ui';
import styles from './styles.module.css';

const ProcessingView = ({ handleSessionClose, isDisabled }) => {
    return (
        <Card className={styles.processingCard}>
            <Card.Header as="h5" className={styles.processingCardHeader}>
                Processing on device.
            </Card.Header>
            <Card.Body className={styles.processingCardBody}>
                <Loader />
                <br />
                <p className={styles.processingTitle}>
                    Your process has been started on your device.
                </p>
                <p className={cn(styles.processingTitle, styles.warningTxt)}>
                    DO NOT CLOSE THIS WINDOW
                </p>
            </Card.Body>
            <Card.Footer
                style={{
                    border: 'none',
                    background: 'none',
                    marginBottom: '24px',
                }}
                className={styles.processingCardFooter}
            >
                <Button
                    block
                    className={styles.processingFooterBtn}
                    variant="outline-primary"
                    onClick={handleSessionClose}
                    disabled={isDisabled}
                >
                    Cancel
                </Button>
            </Card.Footer>
        </Card>
    );
};

ProcessingView.propTypes = {
    handleSessionClose: PropTypes.func,
    isDisabled: PropTypes.bool,
};

export default ProcessingView;
